<template>
  <vue-page-wrapper :title="htmlTitle" :bread-crumbs="breadCrumbItems">
    <stats-bar></stats-bar>
  </vue-page-wrapper>
</template>
<script>
import StatsBar from "@/components/crm/overview/statsBar";
export default {
  components: { StatsBar },
  data() {
    return {
      htmlTitle: "Overview",
      breadCrumbItems: [{ text: "Overview", disabled: true }]
    };
  }
};
</script>
